<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path d="M0 0H48V48H0V0Z" fill="white" fill-opacity="0.01"></path>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3036 42.3796C16.7463 42.8802 17.3828 43.1662 18.051 43.1649C18.7321 43.1543 19.3743 42.8458 19.8082 42.3207L47.4322 8.83611C48.0612 8.11202 48.179 7.07521 47.7284 6.22849C47.2779 5.38177 46.3521 4.90024 45.4002 5.01743C44.7884 5.07266 44.2251 5.37377 43.8393 5.85184L17.9823 37.2651L4.06226 20.9695C3.21649 20.0072 1.75073 19.9127 0.788402 20.7584C-0.17393 21.6042 -0.268424 23.07 0.577344 24.0323L16.3036 42.3796ZM1.40194 21.5389C1.64096 21.3219 1.95283 21.2027 2.27562 21.2051C2.66635 21.1821 3.04724 21.333 3.31619 21.6174L17.9823 38.7965L44.5658 6.50956C44.7923 6.23732 45.1165 6.06465 45.4689 6.02854C45.823 6.00024 46.1745 6.10919 46.4506 6.33286C47.0196 6.8034 47.1029 7.64472 46.6371 8.21766L18.9639 41.7023C18.7237 41.9995 18.3644 42.1756 17.9823 42.1833C17.6055 42.1803 17.248 42.0159 17.0006 41.7317L1.29396 23.3844C0.834418 22.8381 0.881823 22.0279 1.40194 21.5389Z"
        fill={color}
    ></path>
    <mask
        id="mask0_2522_158554"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="5"
        width="48"
        height="39"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.3036 42.3796C16.7463 42.8802 17.3828 43.1662 18.051 43.1649C18.7321 43.1543 19.3743 42.8458 19.8082 42.3207L47.4322 8.83611C48.0612 8.11202 48.179 7.07521 47.7284 6.22849C47.2779 5.38177 46.3521 4.90024 45.4002 5.01743C44.7884 5.07266 44.2251 5.37377 43.8393 5.85184L17.9823 37.2651L4.06226 20.9695C3.21649 20.0072 1.75073 19.9127 0.788402 20.7584C-0.17393 21.6042 -0.268424 23.07 0.577344 24.0323L16.3036 42.3796ZM1.40194 21.5389C1.64096 21.3219 1.95283 21.2027 2.27562 21.2051C2.66635 21.1821 3.04724 21.333 3.31619 21.6174L17.9823 38.7965L44.5658 6.50956C44.7923 6.23732 45.1165 6.06465 45.4689 6.02854C45.823 6.00024 46.1745 6.10919 46.4506 6.33286C47.0196 6.8034 47.1029 7.64472 46.6371 8.21766L18.9639 41.7023C18.7237 41.9995 18.3644 42.1756 17.9823 42.1833C17.6055 42.1803 17.248 42.0159 17.0006 41.7317L1.29396 23.3844C0.834418 22.8381 0.881823 22.0279 1.40194 21.5389Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_2522_158554)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H48V48H0V0Z"
            fill={color}
        ></path>
    </g>
</svg>
